<template>
  <div
    v-if="connection"
    class="text-container"
    @mouseover="hover = true"
    @mouseleave="hover = false"
    @click="$emit('click', connection.cb_uuid)"
  >
    <strong>{{
      connection.cb_label ? connection.cb_label : connection.cb_id
    }}</strong>
  </div>
</template>

<script>
import { bus } from "@/main";

export default {
  name: "JoinCableMenuItem",
  props: {
    connection: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      hover: false
    };
  },

  watch: {
    hover() {
      if (this.hover) {
        bus.$emit(
          "highlight-join-cable-menu",
          this.connection.geom.geojson_geom
        );
      } else {
        bus.$emit("remove-highlight-join-cable-menu");
      }
    }
  }
};
</script>

<style scoped>
.text-container {
  width: 100%;
  text-align: left;
  padding: 5px 20px;
  font-size: 10px;
  cursor: pointer;
}
.text-container:hover {
  background: #f1f1f1;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Content/ObjectMenu/JoinCableMenu/JoinCableMenuItem.vue